import * as moment from 'moment'
import { v4 as uuid } from 'uuid';

export default class Utils {

    static blobToString(blob: any) {
        let u, x;
        u = URL.createObjectURL(blob);
        x = new XMLHttpRequest();
        x.open('GET', u, false);
        x.send();
        URL.revokeObjectURL(u);
        return x.responseText;
    }

    static  b64toBlob(b64Data, contentType, sliceSize?) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      }

      static findAndReplace(string, target, replacement) {
        const length = string.length;
        let i = 0;
        for (i; i < length; i++) {
          string = string.replace(target, replacement);
        }
        return string;
      }

      static decodeHtml(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
      }


      static getDataCorrente(){
        return moment(new Date()).format('DD/MM/YYYY');
       }

      static getHoraCorrente(){
        return moment(new Date()).format('hh:mm:ss');
      }

      static getFormatoDDMMYYYHHMMSS(){
        return moment(new Date()).format('DDMMYYYY') + moment(new Date()).format('HHmm');
       
      }
       static getUuid(){
       return uuid();
       }

      static convertetoDate(timeStamp: any): string {
        const data = new Date(timeStamp);
        return data.toLocaleDateString('pt-BR');
      }
      static convertetoHours(timeStamp: any): string {
        const data = new Date(timeStamp);
        return data.toLocaleTimeString().toString();
      }

      static formatarIncricao(inscricao, tipo) {
        const tamanho = inscricao.toString().length;
      
        let inscr = inscricao;
        let posicao;
        switch (tipo) {
          case '2':
            if (!this.tamanhoQuinze(tamanho, 12)) {
                posicao = tamanho - 12;
                inscr = inscricao.toString().substring(posicao, tamanho);
           }
          break;
          case '1':
           if(!this.tamanhoQuinze(tamanho,14)){
              posicao = tamanho - 14;
             inscr = inscricao.toString().substring(posicao, tamanho);
         }
          break;
          case '3':
           if(!this.tamanhoQuinze(tamanho,11)){
              posicao = tamanho - 11;
             inscr = inscricao.toString().substring(posicao, tamanho);
         }
          break;
          default:
           if(this.tamanhoQuinze(tamanho, 11)){
             inscr = inscricao.toString().substring(3, tamanho);
           }
           break;
       }
         return inscr;
       }
     
       static tamanhoQuinze(tamanho, tamanhoReal):boolean{
         return tamanho === tamanhoReal;
       }
       

       static mascaraInscricao(value, tipo) {

        if (tipo === "3") { //CPF
          while (value.length < 11) value = "0" + value;
          return value.substring(0, 3) + "." + value.substring(3, 6) + "." + value.substring(6, 9) + "-" + value.substring(9, 11);
        }
        else if (tipo === "2") { //CEI
          while (value.length < 14) value = "0" + value;    
          return value.substring(3, 5) + "." + value.substring(5, 8) + "." + value.substring(8, 13) + "-" + value.substring(13, 15);
        }
        else if (tipo === "1") { //CNPJ
          while (value.length < 14) value = "0" + value;
          return value.substring(0, 2) + "." + value.substring(2, 5) + "." + value.substring(5, 8) + "/" + value.substring(8, 12) + "-" + value.substring(12, 14);
        }
      }

    static trataInscricao14pos(inscricao: string) {
      let tamanho = inscricao.length;                
      let  posicao = tamanho - 14;
    return  inscricao.substring(posicao, tamanho);
   
   }    

   static trataInscricao(inscricao){
     let inscr = inscricao;
     if ( inscricao != undefined ) {

     let tamanho =  inscricao.toString().length;
     let  posicao = tamanho - 14;
     inscr =  inscricao.substring(posicao, tamanho);
     }
    return inscr;

   }
  
  
}
